import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {WidgetDirective} from '@components/widget/widget.directive';
import {Tab} from '@models/tab';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE} from '@models/empty';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {AlertService} from '@services/alert.service';
import {Title} from '@angular/platform-browser';
import {TrackingService} from '@services/tracking.service';

@Component({
    selector: 'app-impot',
    templateUrl: './impot.component.html',
    styleUrls: ['./impot.component.scss']
})
export class ImpotComponent implements OnInit {

    @ViewChildren(WidgetDirective) widgets: QueryList<WidgetDirective>;

    tabs: Tab[] = [];
    tab: Tab;
    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    currentUser = null;
    params;

    valid = false;
    displayError = false;

    constructor(
        public dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute,
        private adService: AdService,
        private alertService: AlertService,
        private titleService: Title,
        public trackingService: TrackingService) {
    }

    ngOnInit() {
        this.titleService.setTitle('LyBox - Simulateur d\'impots');
        this.favorite = this.adService.getEmptyFavorite();

        this.favorite.fiscal_choice = 'Foncier forfait';
        this.favorite.fiscal_choice_cat = 'Foncier';

        this.favorite.agence = 0;
        this.favorite.amount_rent_insurance = 0;
        this.favorite.apport = 0;
        this.favorite.banking_fees = 0;

        this.route.data.subscribe(data => {
            this.tabs = data.tabs;
            this.tab = data.tab;
        });

        this.route.queryParams
            .subscribe(params => {
                if (Object.keys(params).length !== 0) {
                    this.favorite.price = params.price;
                    this.favorite.notary_price = Math.round(this.favorite.price * 0.08);
                    this.favorite.agency_fees = params.agency;
                    this.favorite.works_total = params.work;
                    this.favorite.works_help = -1;
                    this.favorite.amount_rent = params.rent;
                    this.favorite.other_bill = parseInt(params.property_tax, 10) + (parseInt(params.charge, 10) * 12);
                    this.favorite.fiscal_choice = params.fiscal_choice;
                    this.favorite.shares_number = params.shares_number;
                    this.favorite.annual_income = params.annual_income;
                    this.favorite.apport = params.apport;
                    this.favorite.duration = params.duration;
                    this.favorite.rate = params.rate;
                    this.favorite.rate_insurance = params.rate_insurance;
                }
            });
    }

    updateAd() {
    }
}
